import * as React from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/utils/cn";

const tagVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-xs px-1.25 pt-1 pb-0.75 text-center text-[0.7rem] font-medium uppercase leading-none tracking-wide transition-colors [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        outline: "border border-border text-foreground",
        success: "bg-success/20 text-success",
        warning: "bg-warning/20 text-warning",
        info: "bg-info/20 text-info",
        destructive: "bg-danger/20 text-danger",
        muted: "bg-muted text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Tag({ className, variant, ...props }: React.ComponentProps<"span"> & VariantProps<typeof tagVariants>) {
  return <span data-slot="tag" className={cn(tagVariants({ variant }), className)} {...props} />;
}

export { Tag, tagVariants };
export type TagVariant = VariantProps<typeof tagVariants>["variant"];
